module.exports = __webpack_public_path__ + "amcharts/images/dragIconH.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconH.gif
// module id = 228
// module chunks = 0